import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { useIsMinWidth } from '@hooks/use-is-min-width';
import { HeadingWithLineHighlights } from '@components/heading-with-line-highlights';
import { Box } from '../../grid';
import { H2, P, H3 as H3Old } from '../../typography';
import { H3 } from '../../typography/new';

const UpsellModalHeader = ({ heading, subheading, description, variant }) => {
  const isDesktop = useIsMinWidth('lg');

  /*
   * The flyout design is a single centred brand-font line on the cream panel — no
   * black highlight bars behind it, and no subheading or description beneath.
   * The legacy centred modal keeps HeadingWithLineHighlights below, so flag-off
   * behaviour is untouched.
   */
  if (variant === 'flyout') {
    return (
      <Box textAlign="center" mb="24px">
        <H3 my="0">{heading}</H3>
      </Box>
    );
  }

  return (
    <Box textAlign="center" zIndex="10" position="relative" mb={{ xs: 1, lg: '0.5rem' }}>
      <HeadingWithLineHighlights
        heading={heading}
        py={0}
        mb="0.5rem"
        color="white"
        headingLevel={H3}
        borderRadius={{ xs: '4.25px', md: '5.5px' }}
        highlightBackgroundColor="black"
        overrideHeadingHighlighting={['highlightAllLines']}
      />
      <P variant={3}>{subheading}</P>
      {isDesktop ? <H3Old mt="0.5rem">{description}</H3Old> : <H2 mt={1}>{description}</H2>}
    </Box>
  );
};

UpsellModalHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  // Optional: no call site passes these (the legacy layout rendered them empty),
  // and the flyout design has neither.
  subheading: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.oneOf(['legacy', 'flyout']),
};

UpsellModalHeader.defaultProps = {
  subheading: undefined,
  description: undefined,
  variant: 'legacy',
};

const ConnectedUpsellModalHeader = observer(UpsellModalHeader);

export { ConnectedUpsellModalHeader as UpsellModalHeader };
